"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
export default function VisionMission() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative min-h-screen w-full overflow-hidden bg-background py-8">
      {}
      <div className="absolute inset-0 opacity-30">
        
      </div>

      {}
      <div className="container relative z-10 mx-auto max-w-4xl px-6">
        <div ref={ref} className="transition-all duration-[350ms] ease-[var(--ease-out-back)]" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(0.5rem)"
      }}>
          <Card className="glass-effect border border-muted/40 bg-surface/80 shadow-strong backdrop-blur-md">
            <CardContent className="space-y-6 p-6">
              {}
              <div className="space-y-4">
                <h2 className="group relative inline-block font-display text-[2.4rem] font-bold leading-tight text-foreground">
                  Vision & Mission
                  <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-secondary transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
                </h2>
                <p className="text-lg leading-relaxed text-muted-foreground">
                  NorthStar Advisory apporte une expertise approfondie aux ESN en stratégie et transformation, avec une expérience significative dans l'accompagnement des organisations vers leur croissance et leur innovation. Notre mission est de fournir un conseil sur mesure avec une approche intégrée. Nous accompagnons les organisations vers l'excellence stratégique et l'innovation durable.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}